import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form, Alert, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axiosInstance from '../../utils/axiosInstance';
import './chatAdvice.css';
import { FaInfoCircle } from 'react-icons/fa';
import { LuSend } from 'react-icons/lu';

const ChatAdvice = ({ userId }) => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [loadingMessages, setLoadingMessages] = useState(true);

    useEffect(() => {
        const loadChatHistory = async () => {
            try {
                const response = await axiosInstance.get(`/chat/messages/${userId}`);
                setMessages(response.data);
                setLoadingMessages(false);
            } catch (error) {
                console.error('Error loading chat history:', error);
                setError('Failed to load chat history.');
                setLoadingMessages(false);
            }
        };

        if (userId) {
            loadChatHistory();
        }
    }, [userId]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        setLoading(true);
        const newMessage = { sender: 'user', text: input };

        try {
            await axiosInstance.post('/chat/send-message', {
                userId,
                text: input
            });
            setMessages([...messages, newMessage]);
            setInput('');
        } catch (error) {
            console.error('Error sending message:', error);
            setError('Failed to send message.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="chat-advice">
            <Row className="justify-content-center my-4">
                <Col xs={12} md={9} lg={7}>
                    <div className="text-center mb-4">
                        <h1 className="display-4 font-weight-bold">Expert Advice</h1>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-info">
                                    Our counselors provide personalized relationship advice tailored to your specific situation. Please allow a few hours for a response. Note: This service complements but does not replace professional counseling or therapy.
                                </Tooltip>
                            }
                        >
                            <Button
                                variant="link"
                                className="d-flex align-items-center text-secondary"
                            >
                                <FaInfoCircle className="me-2" />
                                More Info
                            </Button>
                        </OverlayTrigger>
                    </div>
                    <div className="chat-window mb-3">
                        {loadingMessages ? (
                            <Spinner animation="border" variant="primary" />
                        ) : error ? (
                            <Alert variant="danger">{error}</Alert>
                        ) : (
                            <>
                                {messages.map((msg, index) => (
                                    <div key={index} className={`message ${msg.sender} `}>
                                        <p>{msg.text}</p>
                                    </div>
                                ))}
                            </>
                        )}
                        <div className="refresh-notification d-flex justify-content-center border-0">

                                Refresh the page or come back later to see new messages from our counselors.

                        </div>
                    </div>
                    <Form onSubmit={handleSendMessage}>
                        <div className="d-flex flex-column">
                            <Form.Group controlId="chatInput" className="mb-3">
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    placeholder="Describe your situation or ask a question so we can assist you better."
                                    required
                                    className="form-control-custom"
                                />
                            </Form.Group>
                            <Button
                                type="submit"
                                disabled={loading}
                                className="d-flex align-items-center justify-content-center w-25 send-btn"
                            >
                                {loading ? (
                                    <span>Sending...</span>
                                ) : (
                                    <LuSend size={20} />
                                )}
                            </Button>
                        </div>

                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ChatAdvice;